// extracted by mini-css-extract-plugin
export default {"todayLabelContainer":"MultiDateSelector_todayLabelContainer__L9R9d"};